export const resolveCarrierByTrackingNumber = async (trackingNumber) => {
  const response = await fetch(`/api/v1/carriers/resolve?tracking_number=${trackingNumber}`)

  if (!response.ok)
    throw new Error(`an error occurred when trying to resolve the carrier for the tracking number ${trackingNumber} (HTTP Status: ${response.status})`)

  const responseJson = await response.json()
  const resolvedCarrier = responseJson.data.carrier

  if (resolvedCarrier === null || resolvedCarrier === undefined || resolvedCarrier === '')
    throw new Error(`could not resolve the carrier for the tracking number ${trackingNumber}`)

  return resolvedCarrier
}

/**
 * Wrapper function for resolveCarrierByTrackingNumber that automatically reports errors to Honeybadger
 * 
 * This function handles promise rejections gracefully and reports them to Honeybadger with:
 * - Custom message: "Failed to resolve carrier for the provided tracking number"
 * - Context including the tracking number and original error message
 * - Fingerprint to group similar errors together
 * 
 * The error is still re-thrown so calling code can handle it appropriately.
 * 
 * @param {string} trackingNumber - The tracking number to resolve
 * @returns {Promise<string>} - The resolved carrier name
 * @throws {Error} - Re-throws the original error after reporting to Honeybadger
 */
export const resolveCarrierWithErrorReporting = async (trackingNumber) => {
  try {
    return await resolveCarrierByTrackingNumber(trackingNumber)
  } catch (error) {
    // Report to Honeybadger if available
    if (typeof window !== 'undefined' && window.Honeybadger) {
      window.Honeybadger.notify('Failed to resolve carrier for the provided tracking number', {
        context: {
          tracking_number: trackingNumber,
          error_message: error.message
        },
        fingerprint: `carrier-resolution-error-${trackingNumber}`
      })
    }
    
    // Re-throw the error so calling code can still handle it
    throw error
  }
}
